import { render, staticRenderFns } from "./PhoneNavBtn.vue?vue&type=template&id=757e6577"
import script from "./PhoneNavBtn.vue?vue&type=script&lang=js"
export * from "./PhoneNavBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports